import React from 'react';

/** Standard row counts for Front Desk and other app tables. */
export const FD_TABLE_PER_PAGE_OPTIONS = [5, 10, 20, 50, 100];

/**
 * @param {number} value
 * @param {number} maxAllowed API cap (e.g. Front Desk bookings may max at 100)
 */
export function normalizeFdPerPage(value, maxAllowed = 100) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 20;
  const allowed = FD_TABLE_PER_PAGE_OPTIONS.filter((x) => x <= maxAllowed);
  const cap = allowed.length ? Math.min(maxAllowed, Math.max(...allowed)) : maxAllowed;
  const floor = allowed.length ? Math.min(...allowed) : 5;
  return Math.min(cap, Math.max(floor, n));
}

/**
 * @param {{
 *   id?: string,
 *   label?: string,
 *   value: number,
 *   onChange: (n: number) => void,
 *   maxAllowed?: number,
 * }} props
 */
export function FdPerPageField({ id = 'fd-per-page', label = 'Rows per page', value, onChange, maxAllowed = 100 }) {
  const options = FD_TABLE_PER_PAGE_OPTIONS.filter((n) => n <= maxAllowed);
  const v = options.includes(Number(value)) ? Number(value) : options[0] ?? 20;
  return (
    <label className="fd-bookings-toolbar-field fd-bookings-toolbar-field--per-page">
      <span className="fd-bookings-toolbar-label">{label}</span>
      <select
        id={id}
        className="fd-finance-input"
        value={String(v)}
        onChange={(e) => onChange(Number(e.target.value))}
      >
        {options.map((n) => (
          <option key={n} value={String(n)}>
            {n}
          </option>
        ))}
      </select>
    </label>
  );
}

/**
 * @param {{
 *   meta: { current_page?: number, last_page?: number, per_page?: number, total?: number } | null,
 *   page: number,
 *   setPage: React.Dispatch<React.SetStateAction<number>>,
 *   disabled?: boolean,
 * }} props
 */
export function FdPaginationNav({ meta, page, setPage, disabled = false }) {
  if (!meta) return null;
  const last = meta.last_page ?? 1;
  const cur = meta.current_page ?? page;
  const total = meta.total;
  const per = meta.per_page ?? 0;
  const from = total === 0 || !per ? 0 : (cur - 1) * per + 1;
  const to = total === 0 || !per ? 0 : Math.min(cur * per, total);
  return (
    <div className="fd-bookings-pagination">
      <button
        type="button"
        className="btn-pagination"
        disabled={disabled || cur <= 1}
        onClick={() => setPage((p) => Math.max(1, p - 1))}
      >
        Previous
      </button>
      <span className="fd-bookings-pagination-meta">
        {total != null && total > 0 ? `${from}–${to} of ${total} · ` : ''}
        Page {cur} of {last}
      </span>
      <button
        type="button"
        className="btn-pagination"
        disabled={disabled || cur >= last}
        onClick={() => setPage((p) => p + 1)}
      >
        Next
      </button>
    </div>
  );
}
